module.exports = "/images/Homepage-Workflow DiagramM.jpg";